import React from 'react'


function BannerEditModal() {
  return (
    <div>
      
    </div>
  )
}

export default BannerEditModal
